<template>
  <div class="col-lg-12">
    <!-- Basic elements -->
    <h3 class="mb-3">
      <span>Contact</span>
    </h3>

    <div class="text-dark">
      <p class="d-flex align-items-center">
        <i class="ni ni-email-83"></i>
        <span class="pl-2">jane.doe@gmail.com</span>
      </p>
      <p class="d-flex align-items-center">
        <i class="ni ni-mobile-button"></i>
        <span class="pl-2">+233 213-568-9653</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>
